{
  "intro": "Адреса для переключения при отказе: плавающий IP за несколько секунд направляется на любой сервер своей сетевой зоны, включённый или нет. Система сервера должна знать этот адрес — его настраивают на сервере. Оплачивается помесячно, и IPv4, и IPv6, назначен он или нет.",
  "empty": "Плавающих IP пока нет",
  "emptyLead": "Плавающий IP нужен, когда сервис должен переезжать между серверами без смены DNS: например, на резервный сервер, если основной отказал.",
  "create": "Создать плавающий IP",
  "createLead": "Новый адрес в домашней локации или сразу на сервере.",
  "createSubmit": "Создать адрес",
  "created": "Адрес {{address}} создан",
  "name": "Название",
  "nameHint": "Чтобы узнать адрес в списке, например по сервису, который на нём работает.",
  "description": "Описание",
  "descriptionHint": "Необязательно: для чего этот адрес.",
  "family": "Тип",
  "ipv4Hint": "Один адрес.",
  "ipv6Hint": "Сеть /64.",
  "pricePerMonth": "{{price}} в месяц",
  "where": "Куда",
  "keepFree": "Создать в локации, не назначая",
  "onServer": "Сразу направить на сервер",
  "location": "Домашняя локация",
  "locationHint": "Где адрес числится и оплачивается. Направить его можно на любой сервер той же сетевой зоны.",
  "zone": "Сетевая зона {{zone}}",
  "server": "Сервер",
  "chooseServer": "Выберите сервер",
  "serverHint": "Сервер может быть включён: выключать его не нужно.",
  "billing": "Плавающий IP оплачивается с момента создания и до удаления, назначен он серверу или нет. Удалённый адрес вернуть нельзя: следующий будет другим.",
  "configureNote": "После назначения настройте адрес в системе сервера, иначе сервер не примет трафик на него.",
  "address": "Адрес",
  "home": "Локация",
  "unassigned": "Не назначен",
  "dnsShort": "Обратный DNS",
  "flags": "Свойства",
  "protected": "Защищён",
  "blocked": "Заблокирован",
  "price": "В месяц",
  "createdAt": "Создан",
  "assign": "Назначить серверу",
  "move": "Перенести на другой сервер",
  "assignTitle": "Направить {{address}} на сервер",
  "assignLead": "Подойдёт любой сервер сетевой зоны {{zone}}, включённый или выключенный. Переключение занимает несколько секунд.",
  "assigning": "Направляем {{address}} на сервер",
  "unassign": "Снять с сервера",
  "unassigning": "Снимаем {{address}} с сервера",
  "configure": "Как настроить на сервере",
  "configureTitle": "Настройка {{address}} на сервере",
  "configureLead": "Hetzner направляет трафик адреса на сервер, но система сервера должна сама принять адрес. Добавьте его к основному сетевому интерфейсу (обычно eth0).",
  "configureNow": "Сразу, до перезагрузки:",
  "configurePersist": "Насовсем (Ubuntu и Debian с netplan): файл /etc/netplan/60-floating-ip.yaml, затем sudo netplan apply:",
  "configureOther": "В других системах добавьте адрес к интерфейсу их способом. Если адрес будет переходить между серверами, настройте его на каждом из них заранее.",
  "dns": "Обратный DNS",
  "edit": "Имя, описание и метки",
  "editTitle": "Плавающий IP {{address}}",
  "labels": "Метки",
  "labelsHint": "По одной на строку: ключ=значение.",
  "labelsInvalid": "Строка {{line}}: ключ и значение — до 63 латинских букв, цифр, точек, дефисов и подчёркиваний.",
  "protect": "Включить защиту от удаления",
  "unprotect": "Снять защиту от удаления",
  "delete": "Удалить",
  "deleteTitle": "Удалить плавающий IP {{address}}?",
  "deleteLost": "Адрес будет потерян навсегда: Hetzner выдаст его кому-то другому.",
  "deleteServer": "Сервер {{server}} перестанет получать трафик на этот адрес.",
  "deleteDns": "DNS-записи, которые указывают на этот адрес, перестанут работать.",
  "deleteBilling": "Оплата за адрес прекратится.",
  "deleted": "Адрес {{address}} удалён",
  "why": {
    "protected": "Включена защита от удаления: сначала снимите её.",
    "blocked": "Адрес заблокирован провайдером.",
    "notAssigned": "Адрес ни на какой сервер не направлен.",
    "otherZone": "другая сетевая зона",
    "current": "уже направлен сюда",
    "assigned": "Адрес направлен на сервер: сначала снимите его с сервера."
  },
  "serverCard": {
    "title": "Плавающие IP",
    "empty": "На этот сервер не направлен ни один плавающий IP.",
    "note": "Каждый адрес нужно настроить в системе сервера.",
    "manage": "Все плавающие IP"
  }
}
